export default {
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  insertUnorderedList: 'Bulleted list',
  insertOrderedList: 'Numbered list'
}
